<div class="age-verification-modal">
  <div class="modal-header">
    <img src="assets/img/SG-logo-350px.png" alt="Statement Games" class="sg-logo" />
    <button type="button" class="close-btn" (click)="close()">&times;</button>
  </div>

  <div class="modal-body">
    <h2 class="modal-title" *ngIf="collectDob">Confirm Your Age & Home State</h2>
    <h2 class="modal-title" *ngIf="!collectDob">Confirm Your Home State</h2>
    
    <p class="modal-description" *ngIf="collectDob">
      Before upgrading to <strong>SG Pro</strong> and competing for monthly leaderboard rewards,
      we must confirm that you are <strong>at least 18 years old</strong> and reside in a State which allows daily sports contests.
    </p>

    <p class="modal-description" *ngIf="!collectDob">
      To join this contest, please confirm that you reside in a State which allows daily sports contests.
    </p>

    <p class="modal-instruction" *ngIf="collectDob">Please enter your date of birth and State of residence below:</p>
    <p class="modal-instruction" *ngIf="!collectDob">Please select your State of residence below:</p>

    <form [formGroup]="ageForm" class="age-form">
      <div class="input-row" *ngIf="collectDob">
        <div class="input-group">
          <label [class.error]="monthError">Month</label>
          <input 
            type="text" 
            formControlName="month" 
            placeholder="MM" 
            maxlength="2"
            [class.error-input]="monthError"
            class="form-input"
          />
        </div>

        <div class="input-group">
          <label [class.error]="dayError">Day</label>
          <input 
            type="text" 
            formControlName="day" 
            placeholder="DD" 
            maxlength="2"
            [class.error-input]="dayError"
            class="form-input"
          />
        </div>

        <div class="input-group">
          <label [class.error]="yearError">Year</label>
          <input 
            type="text" 
            formControlName="year" 
            placeholder="YYYY" 
            maxlength="4"
            [class.error-input]="yearError"
            class="form-input"
          />
        </div>
      </div>

      <div class="state-group">
        <label [class.error]="stateError">State of Residence</label>
        <select formControlName="stateOfResidence" class="form-select" [class.error-input]="stateError">
          <option value="">Select State</option>
          <option *ngFor="let state of usStates" [value]="state">{{state}}</option>
        </select>
      </div>

      <div class="checkbox-group" *ngIf="collectDob">
        <input 
          type="checkbox" 
          formControlName="confirmCheckbox" 
          id="confirmAge"
          [class.error-checkbox]="checkboxError"
        />
        <label 
          for="confirmAge" 
          [class.error]="checkboxError"
        >
          I confirm that I am 18 years of age or older
        </label>
      </div>

      <!-- SG-177 finding 8: failures used to be colour-only, and the two
           different checkbox failures were indistinguishable. -->
      <p class="age-error-text" *ngIf="errorMessage" role="alert" aria-live="polite">
        {{errorMessage}}
      </p>

      <button
        type="button"
        class="btn-continue"
        (click)="onContinue()"
      >
        Continue
      </button>

      <a href="javascript:void(0)" class="link-maybe-later" (click)="onMaybeLater()">
        Maybe Later
      </a>
    </form>

    <p class="footer-text" *ngIf="collectDob">
      Age verification is required to access subscription features and cash leaderboard rewards.
    </p>
    <p class="footer-text" *ngIf="!collectDob">
      Territory verification is required to compete in daily sports contests.
    </p>
  </div>
</div>
